module.exports = __webpack_public_path__ + "static/media/TempDisplay.c3595112.gif";